import { render } from "./SurveyQuestionFeedbackList.vue?vue&type=template&id=28947a45&scoped=true"
import script from "./SurveyQuestionFeedbackList.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionFeedbackList.vue?vue&type=script&lang=js"

import "./SurveyQuestionFeedbackList.vue?vue&type=style&index=0&id=28947a45&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28947a45"]])

export default __exports__